import * as model from "@/model/prd/productionExecution/smelting/ElectrodeResistance";
import { newEntityStoreHelper } from "@/store/common/entityModule";
import router from "@/router";
import _ from 'lodash';


function newFilter(paginationFilter = {}) {
  var filter = Object.assign({}, paginationFilter, model.filter)
  return filter;
}

const baseStore = newEntityStoreHelper(() => new model.ElectrodeResistance(), newFilter).buildStore();

function date2str(date) {
  let year = date.getFullYear();
  let month = date.getMonth();
  let d = date.getDate();
  return `${year}-${month + 1}-${d}`;
}

const baseUrl = process.env.VUE_APP_PRODUCTION_API_URL + "production-service/prd";

const electrodeResistanceStore = {
  namespaced: true,
  state: {
    baseModuleUrl: baseUrl,
    currentElectrodeResistance: {},
  },
  mutations: {
    setCurrentElectrodeResistance(state, data) {
      state.currentElectrodeResistance = data;
    },
  },
  actions: {
    jumpToEdit(context, item) {
      context.commit("electrodeResistance/currentElectrodeResistance", item, {
        root: true
      });
      router.push({
        name: "electrodeResistanceEdit"
      });
    },
    findAll(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/electrodeResistance/findAll',
      }, {
          root: true,
        });
    },
    findPage(context, { index, size }) {
      const data = new FormData();
      data.append('page', index)
      data.append('size', size)

      return context.dispatch('api/post', {
        url: baseUrl + '/electrodeResistance/findPage',
        data,
      }, {
          root: true,
        });
    },
    deleteById(context, id) {
      const data = new FormData();
      data.append('id', id)
      return context.dispatch('api/post', {
        url: baseUrl + '/electrodeResistance/delete',
        data,
      }, {
          root: true,
        });
    },
    getLength(context) {
      return context.dispatch('api/post', {
        url: baseUrl + '/electrodeResistance/getLength',
      }, { root: true })
    },
    saveCurrentElectrodeResistance(context) {
      return context.dispatch('saveElectrodeResistance', context.state.currentElectrodeResistance);
    },
    saveElectrodeResistance(context, electrodeResistance) {
      let data = new FormData();
      let id = electrodeResistance.id > 0 ? electrodeResistance.id : -1;
      data.append('id', id);
      data.append('date', date2str(electrodeResistance.date));
      data.append('furnaceNumber', electrodeResistance.furnaceNumber);
      data.append('furnaceTime', electrodeResistance.furnaceTime);
      data.append('drillNumber', electrodeResistance.drillNumber);
      data.append('startTime', electrodeResistance.startTime);
      data.append('endTime', electrodeResistance.endTime);
      data.append('first', electrodeResistance.first);
      data.append('second', electrodeResistance.second);
      data.append('third', electrodeResistance.third);
      return context.dispatch('api/post', {
        url: baseUrl + '/electrodeResistance/save',
        data,
      }, {
          root: true,
        })
    }
  }
}

export default _.defaultsDeep(electrodeResistanceStore, baseStore); // 合并 teamShiftStore 和 baseStore (冲突时选前者)